<template>
  <div class="cont">
    <img
      :src="imgSrc"
      class="img"
    >
  </div>
</template>

<script>
export default {
  props: {
    file: File,
    isMime: Boolean
  },

  data () {
    return {
      imgSrc:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=='
    }
  },

  created () {
    var vm = this
    if (this.isMime) {
      let documentExtension = this.file.name.split('.').pop()
      this.imgSrc = '/images/mimes/' + documentExtension + '.png'
    } else {
      if (this.file) {
        var reader = new FileReader()
        reader.onload = function (e) {
          vm.imgSrc = e.target.result
        }

        reader.readAsDataURL(this.file)
      }
    }
  }
}
</script>

<style scoped>
.cont {
  width: 100%;
  height: 100%;
  font-size: 9px;
}

.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
